import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  // queryDouYinUser:`/apis/moyin-account/moyou/activity/queryDouYinUser`,
  queryDouYinUser:`/apis/moyin-account/moyou/activity/bindAccountList`,
  // 删除绑定账号
  // delBindInfo: {
  //   custom: true,
  //   url: (data: any)=>`/apis/moyin-account/moyou/activity/deleteBindInfo?openId=${data.openId}`,
  //   method: 'post'
  // }
  delBindInfo: {
    custom: true,
    url: (data: any)=>`/apis/moyin-account/moyou/activity/deleteBindInfo?id=${data.id}`,
    method: 'post'
  }
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"activityManager"
  })
}